import styled from 'styled-components';

const FormLayout = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  padding: 16px 16px 24px;
`;

export { FormLayout };
